module.exports = __webpack_public_path__ + "img/wallpaper-merluzzo.290609f6.png";